import { IS_CONNECTING, IS_END_CONNECT } from "./constants";

export function isConnect() {
  return {
    type: IS_CONNECTING,
  };
}

export function endConnect() {
  return {
    type: IS_END_CONNECT,
  };
}
